module.exports = __webpack_public_path__ + "static/media/11.99492839.jpg";